<template>
  <div class="task-export-data btnHover" @click="exportData">
    <i class="icon iconfont iconicon_share"></i>
    <span>导出数据</span>
  </div>
</template>
<script>
import api from '@/services/api/mine/mine'
import { mapState } from 'vuex'
export default {
  props: ['uid'],
  data() {
    return {

    }
  },
  computed: {
    ...mapState('mine/mine', {
      queryMsg: state => state.queryMsg
    }),
  },
  methods: {
    async exportData() {
      await api.exportRelatedToMeTasksList({ project_id: this.queryMsg.project_id, my_execution: this.queryMsg.my_execution, keyword: this.queryMsg.keyword, uid: this.uid })
    }
  },
}
</script>
<style lang="scss">
.task-export-data {
  color: rgba(32, 32, 32, 0.6);
  font-size: 14px;
  font-weight: 400;
  padding: 8px;
  i {
    color: rgba(32, 32, 32, 0.6);
    font-weight: 400;
    margin-right: 9px;
    font-size: 12px;
  }
}
</style>
